import React from 'react'
import styles from './link-resent.styles'
import injectSheet from 'react-jss'
import Container from '../components/container/container'
import Title from '../components/title/title'
import Description from '../components/description/description'
import duckFixer from '../../../../images/duck-fixer.gif'

const LinkResent = ({ classes }) => (
  <Container>
    <img className={classes.img} src={duckFixer} alt="Duck fixer" />
    <Title>A new link is on its way.</Title>
    <Description>
      <p>
        Please check your inbox.
        <br />
        We've sent you an email with a new link.
      </p>
    </Description>
  </Container>
)

export default injectSheet(styles)(LinkResent)
